import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { CustomKegMonService } from 'app/services/dal/customKegMon.service';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import * as Action from './actions'
import { shouldLoadData, trackLoading } from '../effect-helpers';
import * as fromCustomKegMon from './reducer';



@Injectable()
export class CustomKegMonEffects {

  constructor(
    private actions$: Actions,
    private store: Store,
    private service: CustomKegMonService) { }

  getKegs$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(Action.loadItems),
        shouldLoadData(
          this.store,
          'customKegMon',
          (action) => action.barId,
          fromCustomKegMon.selectAllItems
        ),
        switchMap((action) =>
          trackLoading(
            this.store,
            'customKegMon',
            action.barId,
            this.service.getItems(action.barId).pipe(
              map(items => Action.loadItemsSuccess({ items: items })),
              catchError(error => of(Action.loadItemsFailure({ error })))
            )
          )
        )
      );
  });


}
